export default "__VITE_ASSET__CxZZ93Oo__"